// ============================================================
// api/careRotaRoles.js  (CareRota role model, 2026-07-14)
// Admin-portal client for the CareRota module-role endpoints.
// Clone of api/careChargeRoles.js against the CareRota overlay
// (two-value vocabulary rota_coordinator | rota_manager). No tier —
// CareRota has no scope-tier axis; rota_manager differs from
// rota_coordinator by CareRota-CONFIG (settings) write, not scope.
//
// Backend reference:
//   admin-carerota-role-get.js    (GET    -> { coreRole, coreRoleApplicable, current, history })
//   admin-carerota-role-grant.js  (POST   { careRotaRole })
//   admin-carerota-role-revoke.js (DELETE -> { revoked, careRotaRole? })
//
// One path, three methods:
//   /api/mgmt/admin/users/{clientUserId}/carerota-role
// ============================================================

import { apiGet, apiPost, apiDelete } from './client';

export async function getCareRotaRole(clientUserId) {
  return apiGet(`/mgmt/admin/users/${clientUserId}/carerota-role`);
}

export async function grantCareRotaRole(clientUserId, { careRotaRole }) {
  return apiPost(`/mgmt/admin/users/${clientUserId}/carerota-role`, { careRotaRole });
}

export async function revokeCareRotaRole(clientUserId) {
  return apiDelete(`/mgmt/admin/users/${clientUserId}/carerota-role`);
}
